/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import apiService from '../../axios/apiService';
import PropTypes from 'prop-types';
import { useUserClinic } from '../../hooks/useUserClinic';
import BranchForm from './BranchForm';

const EditBranch = forwardRef(function EditBranch(
  { formValues, onSuccess, onError },
  ref
) {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { userClinic } = useUserClinic();

  useImperativeHandle(
    ref,
    () => ({
      reset: formRef?.current?.reset // eslint-disable-line no-unused-labels
    }),
    []
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await apiService.updateBranch(
        data.clinicLocationId,
        {
          address: data.address,
          zipcode: data.zipcode,
          contactNumber: data.contactNumber,
          status: data.status,
        },
        {
          clinicId: userClinic?.clinicId,
        }
      );
      setLoading(false);
      onSuccess?.(response);
    } catch (error) {
      setLoading(false);
      onError?.(error);
    }
  };

  return (
    <BranchForm
      formValues={formValues}
      onSubmit={onSubmit}
      loading={loading}
      ref={formRef}
    />
  );
});

EditBranch.propTypes = {
  formValues: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default EditBranch;
